// @ts-strict-ignore
import Link from 'next/link';
import { useState } from 'react';
import { useSelector } from 'src/store/store';
import Card from 'src/components/card';
import i18n from 'src/utils/translate';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Element, Section } from 'src/constants/footfall';
import Icon from 'src/components/icon';

export default function TopicList({ topics = [] }): JSX.Element {
  const [isShowAll, setIsShowAll] = useState(false);
  const { slug: communitySlug } = useSelector(({ context }) => context.currentCommunity);

  if (topics.length === 0) return null;

  const sortedTopics = [...topics].sort((a, b) => b.postCount - a.postCount);
  const topicList = isShowAll ? sortedTopics : sortedTopics.splice(0, 5);
  const totalCount = topics.reduce((total, c) => total + c.postCount, 0);

  return (
    <Card title={i18n.t('Topics')}>
      <div className="sidebar__list">
        <Link
          as={`/${communitySlug}/posts`}
          className="sidebar__list__link"
          href={`/community/communityPosts?communitySlug=${communitySlug}`}
        >

          {i18n.t('All posts')}({totalCount})
        </Link>
      </div>
      {topicList.map(({ id, name, postCount }) => (
        <div className="sidebar__list" key={id}>
          <Link
            as={`/${communitySlug}/posts/topic/${encodeURIComponent(name.toLowerCase())}`}
            className="sidebar__list__link"
            href={`/community/communityPosts?communitySlug=${communitySlug}&topicName=${encodeURIComponent(name.toLowerCase())}`}
            onClick={() => {
              trackFootfallEvent(Event.Clicked, {
                clickType: 'post-side-bar',
                clickMetadata: {
                  section: Section.PostsSideBar,
                  element: Element.Topic,
                },
              });
            }}
          >

            {name}({postCount})
          </Link>
        </div>
      ))}
      {!isShowAll && topics.length > 5 && (
        <a
          className="sidebar__show-more-btn"
          href="#"
          onClick={e => {
            e.preventDefault();
            setIsShowAll(true);
            trackFootfallEvent(Event.Clicked, {
              clickType: 'post-side-bar',
              clickMetadata: {
                section: Section.PostsSideBar,
                element: Element.SeeAllTopics,
              },
            });
          }}
        >
          {i18n.t('See all topics')} <Icon icon="open-down" />
        </a>
      )}
    </Card>
  );
}

